import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=283a8b58&"
import script from "./Update.vue?vue&type=script&lang=ts&"
export * from "./Update.vue?vue&type=script&lang=ts&"
import style0 from "./Update.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports